export default [
  {
    url: '/back',
    name: '분야 바로가기',
    icon: 'ArrowLeftIcon',
    activeCode: '',
  },
  {
    url: '/home',
    name: '대시보드',
    icon: '',
    activeCode: '',
  },
  {
    url: '/',
    name: '시스템 계약 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/118/page',
        name: '계약정보',
        icon: 'w-line',
        activeCode: '',
        groupName: ['118'],
      },
      {
        url: '/tab/105',
        name: '수급업체 등록 요청',
        icon: 'w-line',
        activeCode: '',
        groupName: ['105'],
      },
    ]
  },
  {
    url: '/',
    name: '신규 사업장 등록 요청 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/300',
        name: '직영사업장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['300'],
      },
      {
        url: '/tab/301',
        name: '도급·용역·위탁 사업장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['301'],
      },
      {
        url: '/tab/302',
        name: '발주 사업장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['302'],
      },
      {
        url: '/tab/303',
        name: '시설물',
        icon: 'w-line',
        activeCode: '',
        groupName: ['303'],
      },
    ]
  },
  {
    url: '/',
    name: '사업장/시설물 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/field/info/type-a',
        // name: '사업장(직접수행) 관리',
        name: '직영사업장',
        icon: 'w-line',
        activeCode: 'field-workplace',
      },
      {
        url: '/field/info/type-b',
        name: '도급·용역·위탁 사업장',
        icon: 'w-line',
        activeCode: 'field-workplace2',
      },
      {
        url: '/field/info/type-c',
        // name: '사업장현황',
        name: '발주 사업장',
        icon: 'w-line',
        activeCode: 'field-field',
      },
      {
        url: '/field/info/type-d',
        name: '시설물',
        icon: 'w-line',
        activeCode: 'field-facility',
      },
    ]
  },
  {
    url: '/',
    name: '안전보건조직체계',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/282',
        name: '안전보건관리책임자 선임',
        icon: 'w-line',
        activeCode: '',
        groupName: ['282'],
      },
      {
        url: '/tab/126',
        name: '안전보건 조직 체계도',
        icon: 'w-line',
        activeCode: '',
        groupName: ['126'],
      },
      // {
      //   url: '/company/info',
      //   name: '소속부서 및 담당업체 정보',
      //   icon: 'w-line',
      //   activeCode: 'company-info',
      // },
      // {
      //   url: '/tab/141',
      //   name: '안전보건 관련 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['141'],
      // },
      // {
      //   url: '/tab/136',
      //   name: '안전보건 점검 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['136'],
      //   submenu: []
      // },
      // {
      //   url: '/tab/138',
      //   name: '비상 연락/지원 체계도',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['138'],
      // },
      {
        url: '/tab/304',
        name: '유관기관 비상연락망',
        icon: 'w-line',
        activeCode: '',
        groupName: ['304'],
      },
      // {
      //   url: '/tab/119',
      //   name: '안전보건관리 책임자 지정 외',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['119', '120', '121', '122', '123', '125'],
      // },
    ]
  },
  {
    url: '/',
    name: '안전보건관리 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/137',
        name: '안전보건 점검 계획',
        icon: 'w-line',
        activeCode: '',
        groupName: ['137'],
      },
      {
        url: '/tab/101',
        name: '안전보건 경영방침',
        icon: 'w-line',
        groupName: ['101'],
      },
      {
        url: '/tab/134',
        name: '반기별 보고',
        icon: 'w-line',
        activeCode: '',
        groupName: ['134'],
      },
      {
        url: '/tab/286',
        name: '수행평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['286', '287'],
      },
      {
        url: '/tab/131',
        name: '수시 점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['131'],
      },
      {
        url: '/tab/150',
        name: '안전보건 확보 의무',
        icon: 'w-line',
        activeCode: '',
        groupName: ['150'],
      },
      {
        url: '/tab/152',
        name: '산업안전보건위원회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['152']
      },
      {
        url: '/tab/153',
        name: '노사협의체',
        icon: 'w-line',
        activeCode: '',
        groupName: ['153']
      },
    ]
  },
  {
    url: '/',
    name: '건강진단 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/318',
        name: '특수건강진단',
        icon: 'w-line',
        activeCode: '',
        groupName: ['318'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건 예산',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: "/tab/_106/page",
        name: "부서별 안전보건 예산(A형)",
        icon: "w-line",
        activeCode: "",
        groupName: ["106/page"],
      },
      {
        url: '/tab/_154/page',
        name: '부서별 안전보건 예산(B형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['154/page'],
      },
      {
        url: '/tab/_155/page',
        name: '부서별 안전보건 예산(C형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['155/page'],
      },
      {
        url: '/tab/106',
        name: '안전보건 예산(A형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['106'],
      },
      {
        url: '/tab/154',
        name: '안전보건 예산(B형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['154'],
      },
      {
        url: '/tab/155',
        name: '안전보건 예산(C형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['155'],
      },
    ]
  },
  {
    url: '/',
    name: '교육 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/107',
        name: '안전·보건 교육',
        icon: 'w-line',
        activeCode: '',
        groupName: ['107'],
      },
      {
        url: '/tab/132/page',
        name: '교육 모니터링',
        icon: 'w-line',
        activeCode: '',
        groupName: ['132'],
      },
    ]
  },
  {
    url: '/',
    name: '유해·위험요인 관리',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/108',
        name: '유해위험요인 조사표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['108', '156', '157', '158', '159', '305', '306'],
      },
      {
        url: '/tab/160',
        name: '유해·위험요인 점검(개선)사항 요청',
        icon: 'w-line',
        activeCode: '',
        groupName: ['160'],
      },
    ]
  },
  {
    url: '/',
    name: '위험성평가',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/288',
        name: '[공통]현장순회점검일지(현업근로자 위험성평가)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['288'],
      },
      {
        url: '/tab/161',
        name: '정기 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['161'],
      },
      {
        url: '/tab/162',
        name: '수시 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['162'],
      },
      {
        url: '/tab/151',
        name: '위험성평가협의회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['151'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건 점검',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/163',
        name: '일일안전보건점검일지',
        icon: 'w-line',
        activeCode: '',
        groupName: ['163'],
      },
      {
        url: '/tab/100',
        name: '작업장 합동점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['100'],
      },

      // 신규추가
      {
        url: '/tab/289',
        name: '[공통]안전보건 순회점검표(사무실)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['289'],
      },
      {
        url: '/tab/291',
        name: '[공통]안전 순회점검표(현장)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['291'],
      },
      {
        url: '/tab/290',
        name: '[공통]보건 순회점검표(현장)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['290'],
      },
      {
        url: '/tab/292',
        name: '[공통]근골격계 증상조사표(근로자)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['292'],
      },
      {
        url: '/tab/293',
        name: '[공통]근골격계부담작업 체크리스트',
        icon: 'w-line',
        activeCode: '',
        groupName: ['293'],
      },
      {
        url: '/tab/296',
        name: '[공통]동청사 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['296'],
      },

      // 가나다순 정렬
      {
        url: '/tab/219',
        name: '(건설현장) 건설기계·장비별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['219'],
      },
      {
        url: '/tab/221',
        name: '(건설현장) 공정별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['221'],
      },
      {
        url: '/tab/216',
        name: '(건설현장) 사고유형별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['216', '217', '218'],
      },
      {
        url: '/tab/220',
        name: '(건설현장) 위험작업별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['220'],
      },
      {
        url: '/tab/112',
        name: '(건설현장) 일반관리',
        icon: 'w-line',
        activeCode: '',
        groupName: ['112'],
      },
      {
        url: '/tab/180',
        name: '가지치기',
        icon: 'w-line',
        activeCode: '',
        groupName: ['180'],
      },
      {
        url: '/tab/210',
        name: '건설기계·장비별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['210'],
      },
      {
        url: '/tab/198',
        name: '계절성 업무에 따른 관리대책',
        icon: 'w-line',
        activeCode: '',
        groupName: ['198'],
      },
      {
        url: '/tab/213',
        name: '곤돌라 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['213'],
      },
      {
        url: '/tab/200',
        name: '근골격계 질환',
        icon: 'w-line',
        activeCode: '',
        groupName: ['200'],
      },
      {
        url: '/tab/188',
        name: '근로자 건강관리(공통)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['188'],
      },
      {
        url: '/tab/196',
        name: '급식 점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['196'],
      },
      {
        url: '/tab/203',
        name: '기계식 주차설비 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['203'],
      },
      {
        url: '/tab/212',
        name: '기계톱 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['212'],
      },
      {
        url: '/tab/176',
        name: '기둥, 벽, 보, 천장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['176'],
      },
      {
        url: '/tab/166',
        name: '냉온수기 및 보일러 설비',
        icon: 'w-line',
        activeCode: '',
        groupName: ['166'],
      },
      {
        url: '/tab/226',
        name: '다목적 체육관 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['226'],
      },
      {
        url: '/tab/224',
        name: '다목적실 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['224'],
      },
      {
        url: '/tab/110',
        name: '도로 보수',
        icon: 'w-line',
        activeCode: '',
        groupName: ['110'],
      },
      {
        url: '/tab/189',
        name: '밀폐공간 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['189'],
      },
      {
        url: '/tab/230',
        name: '보도 육교 승강기 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['230'],
      },
      {
        url: '/tab/229',
        name: '보도 육교 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['229'],
      },
      {
        url: '/tab/205',
        name: '복도 및 화장실청소',
        icon: 'w-line',
        activeCode: '',
        groupName: ['205'],
      },
      {
        url: '/tab/171',
        name: '부대 시설',
        icon: 'w-line',
        activeCode: '',
        groupName: ['171'],
      },
      {
        url: '/tab/172',
        name: '비상설비',
        icon: 'w-line',
        activeCode: '',
        groupName: ['172'],
      },
      {
        url: '/tab/199',
        name: '사다리 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['199'],
      },
      {
        url: '/tab/182',
        name: '산불예방감시',
        icon: 'w-line',
        activeCode: '',
        groupName: ['182'],
      },
      {
        url: '/tab/184',
        name: '산불진화작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['184'],
      },
      {
        url: '/tab/227',
        name: '샤워실 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['227'],
      },
      {
        url: '/tab/174',
        name: '소방 및 신호기',
        icon: 'w-line',
        activeCode: '',
        groupName: ['174'],
      },
      {
        url: '/tab/173',
        name: '소방용수 탱크',
        icon: 'w-line',
        activeCode: '',
        groupName: ['173'],
      },
      {
        url: '/tab/113',
        name: '수영장 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['113'],
      },
      {
        url: '/tab/225',
        name: '스트레칭실 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['225'],
      },
      {
        url: '/tab/206',
        name: '승강기 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['206'],
      },
      {
        url: '/tab/168',
        name: '시설물 관리(공통)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['168'],
      },
      {
        url: '/tab/169',
        name: '시설물 내부',
        icon: 'w-line',
        activeCode: '',
        groupName: ['169'],
      },
      {
        url: '/tab/170',
        name: '시설물 외부',
        icon: 'w-line',
        activeCode: '',
        groupName: ['170'],
      },
      {
        url: '/tab/223',
        name: '실내체육관 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['223'],
      },
      {
        url: '/tab/179',
        name: '실외기 및 완강기',
        icon: 'w-line',
        activeCode: '',
        groupName: ['179'],
      },
      {
        url: '/tab/194',
        name: '쓰레기 수거 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['194'],
      },
      {
        url: '/tab/201',
        name: '안전보건교육',
        icon: 'w-line',
        activeCode: '',
        groupName: ['201'],
      },
      {
        url: '/tab/233',
        name: '어린이집 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['233'],
      },
      {
        url: '/tab/211',
        name: '예초기 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['211'],
      },
      {
        url: '/tab/193',
        name: '외벽 청소 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['193'],
      },
      {
        url: '/tab/164',
        name: '요양보호사',
        icon: 'w-line',
        activeCode: '',
        groupName: ['164'],
      },
      {
        url: '/tab/208',
        name: '위험대비 매뉴얼 대응조치 점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['208'],
      },
      {
        url: '/tab/202',
        name: '위험작업별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['202'],
      },
      {
        url: '/tab/190',
        name: '유해화학물질 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['190'],
      },
      {
        url: '/tab/197',
        name: '응급조치',
        icon: 'w-line',
        activeCode: '',
        groupName: ['197'],
      },
      {
        url: '/tab/192',
        name: '작업장 바닥 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['192'],
      },
      // {
      //   url: '/tab/209',
      //   name: '작업장 합동점검',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['209'],
      // },
      {
        url: '/tab/178',
        name: '전기 외함',
        icon: 'w-line',
        activeCode: '',
        groupName: ['178'],
      },
      {
        url: '/tab/177',
        name: '전기시설',
        icon: 'w-line',
        activeCode: '',
        groupName: ['177'],
      },
      {
        url: '/tab/207',
        name: '전기작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['207'],
      },
      {
        url: '/tab/231',
        name: '제방 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['231'],
      },
      {
        url: '/tab/165',
        name: '종사자 및 주차시설',
        icon: 'w-line',
        activeCode: '',
        groupName: ['165'],
      },
      {
        url: '/tab/175',
        name: '주차시설',
        icon: 'w-line',
        activeCode: '',
        groupName: ['175'],
      },
      {
        url: '/tab/191',
        name: '중량물 작업 시 안전점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['191'],
      },
      {
        url: '/tab/214',
        name: '지게차 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['214'],
      },
      {
        url: '/tab/181',
        name: '진드기 및 질병예방',
        icon: 'w-line',
        activeCode: '',
        groupName: ['181'],
      },
      {
        url: '/tab/204',
        name: '청소(미화) 점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['204'],
      },
      {
        url: '/tab/187',
        name: '청소차량',
        icon: 'w-line',
        activeCode: '',
        groupName: ['187'],
      },
      {
        url: '/tab/186',
        name: '청소차량 및 환경미화원',
        icon: 'w-line',
        activeCode: '',
        groupName: ['186'],
      },
      {
        url: '/tab/185',
        name: '청원경찰',
        icon: 'w-line',
        activeCode: '',
        groupName: ['185'],
      },
      {
        url: '/tab/228',
        name: '탈의실 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['228'],
      },
      {
        url: '/tab/183',
        name: '풀베기',
        icon: 'w-line',
        activeCode: '',
        groupName: ['183'],
      },
      {
        url: '/tab/167',
        name: '행사자 동선 및 관계자',
        icon: 'w-line',
        activeCode: '',
        groupName: ['167'],
      },
      {
        url: '/tab/222',
        name: '헬스장 안전점검표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['222'],
      },
      {
        url: '/tab/195',
        name: '화기·용접 작업',
        icon: 'w-line',
        activeCode: '',
        groupName: ['195'],
      },
      // {
      //   url: '/tab/232',
      //   name: '방파제 안전점검표',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['232'],
      // },

    ]
  },
  {
    url: '/',
    name: '재해발생 대비 대책',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/116/page',
        name: '(재해발생) 산업재해 발생 시 보고 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['116'],
      },
      {
        url: '/tab/238/page',
        name: '(재해발생) 비상조치 및 처리 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['238'],
      },
      {
        url: '/tab/239',
        name: '비상대피 훈련·교육·자체평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['239', '240', '241'],
      },
      {
        url: '/tab/242',
        name: '비상조치계획 수립',
        icon: 'w-line',
        activeCode: '',
        groupName: ['242'],
      }
    ]
  },
  {
    url: '/',
    name: '재해발생보고',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/117',
        name: '산업재해조사표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['117'],
      },
      {
        url: '/tab/244',
        name: '중대재해 발생 보고',
        icon: 'w-line',
        activeCode: '',
        groupName: ['244'],
      },
      {
        url: '/tab/245',
        name: '재발방지계획서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['245'],
      },
    ]
  },
  {
    url: '/',
    name: '자료실',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/filelibrary/340',
        name: '자료실',
        activeCode: 'filelibrary-340',
        icon: 'w-line'
      },
    ]
  },
  {
    url: '/community',
    name: '커뮤니티',
    slug: 'community',
    icon: '',
    submenu: [
      {
        url: '/community/businessnews',
        name: '기관장 메세지',
        activeCode: 'community_businessnews',
        icon: 'w-line'
      },
      {
        url: '/community/healthinfo',
        name: '안전보건 주요 일정',
        activeCode: 'community_healthinfo',
        icon: 'w-line'
      },
      {
        url: '/community/unitbusinessnews',
        name: '구성원 요청사항',
        activeCode: 'community_unitbusinessnews',
        icon: 'w-line'
      },
      {
        url: '/community/qna',
        name: 'Q&A',
        activeCode: 'community_qna',
        icon: 'w-line'
      }
    ]
  },
  {
    url: '/mypage',
    name: '마이페이지',
    slug: 'safety',
    icon: '',
    submenu: [
      {
        url: '/mypage/workstatus',
        name: '업무현황',
        slug: '',
        icon: 'w-line'
      },
      {
        url: '/mypage/alert',
        name: '알림',
        slug: '',
        icon: 'w-line'
      },
      {
        url: '/',
        name: '결재관리',
        slug: '',
        icon: 'w-line',
        submenu: [
          {
            url: '/approval-request',
            name: '결재요청함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-await',
            name: '결재대기함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-process',
            name: '결재진행함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-complete',
            name: '완료문서함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-reject',
            name: '반려문서함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-reference',
            name: '참조/회람문서함',
            slug: '',
            icon: 'w-line'
          },
        ]
      },
      {
        url: '/',
        name: '설정',
        slug: '',
        icon: 'w-line',
        submenu: [
          {
            url: '/mypage/info-update',
            name: '개인정보변경',
            slug: '',
            icon: 'w-line'
          },
        ]
      }
    ]
  }
]
